import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FarmersService } from '~/api/services/farmers/index'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'

interface BlockFarmerProps {
  blockModalData: any
  handleClose: (submited?: boolean) => void
}

const BlockFarmer: React.FC<BlockFarmerProps> = (props) => {
  const { t } = useTranslation()
  const { blockModalData, handleClose } = props

  const [isBusy, setIsBusy] = useState(false)

  const action = blockModalData?.status === 1 ? t('Block') : t('Unblock')
  const name = blockModalData?.companyName || ''

  async function handleBlockUnblockFarmer(farmer) {
    setIsBusy(true);
    try {
      if (farmer.status === 1) {
        await FarmersService.blockFarmer(farmer.id);
        notify(t('User successfully blocked'), 'success')
      } else {
        await FarmersService.unblockFarmer(farmer.id);
        notify(t('User successfully unblocked'), 'success')
      }
      handleClose(true)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false);
  }

  return <Dialog
    isDialogOpen={Boolean(blockModalData)}
    textClose={t('Close')}
    isLoading={isBusy}
    handleClose={() => handleClose()}
    textSubmit={t(`${blockModalData?.status === 1 ? 'Block' : 'Unblock'}`)}
    handleSubmit={() => handleBlockUnblockFarmer(blockModalData)}
    textContent={t('Do you want to {{action}} {{name}}?', { action, name })}
    textHeader={t('{{action}} {{name}}', { action, name })}
    type={'abort'}
  />
}
export default BlockFarmer